export const RESET_PASSWORD_BEGIN = "RESET_PASSWORD_BEGIN";
export const resetPasswordBegin = (currentPassword, newPassword) => ({
  type: RESET_PASSWORD_BEGIN,
  currentPassword,
  newPassword,
});

export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const resetPasswordSuccess = () => ({
  type: RESET_PASSWORD_SUCCESS,
});

export const RESET_PASSWORD_FAILED = "RESET_PASSWORD_FAILED";
export const resetPasswordFailed = () => ({
  type: RESET_PASSWORD_FAILED,
});
